module.exports = __webpack_public_path__ + "img/cat-empty-servicios.47d59d50.svg";